<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { RuleEngine } from "../RuleEngine"

    // Choices from MailboxFilter
    export let currentChoices = null

    export let value: number = null
    export let name: string = null
    export let dependsOn: OfferAssistantDependsOnRule[]
    export let label: string
    export let placeholder: string
    export let defaultValue: number
    export let disabled: boolean = false
    export let inputProps: {
        [key: string]: any
    } = null
    export let values: { [key: string]: any }
    values = values || null

    if (!value) {
        if (defaultValue) {
            value = defaultValue
        }

        // Takeover selected mailbox totel value from MailboxFilter(Konfigurator) and overwrite any default values
        if (currentChoices && currentChoices[name] && value !== currentChoices[name]) {
            value = currentChoices[name]
        }
    }

    const dispatch = createEventDispatcher()
    let input: HTMLInputElement
    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true

    const onInput = () => {
        dispatch("input", value)
    }

    $: if (dependsOn) {
        displayComponent = ruleEngine.resolve(dependsOn, values)
        if (!displayComponent) {
            value = null
        } else {
            if (!value) {
                value = defaultValue
            }
        }
    }
</script>

{#if displayComponent}
    <div class="number-input">
        {#if label}
            <label for="">{label}</label>
        {/if}
        <input
            bind:this="{input}"
            bind:value
            on:input="{onInput}"
            type="number"
            {placeholder}
            {disabled}
            {...inputProps}
        />
    </div>
{/if}
